import React, {memo} from 'react';
//Material UI Components
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import {Avatar, Grid, makeStyles, Tooltip} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    addButton: {
        backgroundColor: theme.palette.primary.main,
        cursor: "pointer"
    }
}));

const MembersAvatar = memo(({memberRecords}) => {
    const classes = useStyles();
    return (
        <Grid container>
            {memberRecords?.length > 0 && (
                <AvatarGroup max={5}>
                    {memberRecords.map(({display_name, color}, i) =>
                        <Tooltip key={i} title={display_name}>
                            <Avatar style={color} alt={display_name} src="/"/>
                        </Tooltip>
                    )}
                </AvatarGroup>
            )}
            <Tooltip title="Add More" className={classes.addButton}>
                <Avatar alt="+" src="/">+</Avatar>
            </Tooltip>
        </Grid>
    )
})

export default MembersAvatar;
